<template>
  <div>
    <b-row>
      <b-col cols="12" sm="3" md="3" lg="3" xl="1">
        <input
          @keyup.enter="enter()"
          :min="0.0"
          :step="0.01"
          v-model="cantidad"
          class="form-control input-dark colorBorde"
          placeholder="Cantidad (*)"
          required
        />
      </b-col>
      <b-col cols="12" sm="3" md="3" lg="3" xl="2">
        <select
          :disabled="dataitem.freesale == 0"
          class="custom-select mr-sm-2 input-placedark input-dark colorBorde"
          id="inlineFormCustomSelect"
          v-model="unidadMedidaCantidad"
        >
          <option
            :value="unidad.codigo"
            v-for="unidad in unidades"
            v-bind:key="unidad.id"
          >{{ unidad.descripcion }}</option>
        </select>
      </b-col>
      <b-col cols="12" sm="3" md="3" lg="3" xl="1">
        <b-input-group>
          <b-form-input
            :disabled="this.$store.getters.getcomprobante==7 && this.dataitem.idReceptor.length == 0"
            class="form-control input-placedark input-dark colorBorde"
            placeholder="C. Prod."
            maxlength="30"
            v-model="codigoProducto"
            @change="getReceiversProductCode"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col cols="12" sm="3" md="3" lg="3" xl="1">
        <b-input-group>
          <b-form-input
            v-if="tipoOperacion != '0200'"
            :disabled="this.$store.getters.getcomprobante==7 && this.dataitem.idReceptor.length == 0"
            :placeholder="placeholdercodigo"
            class="form-control input-placedark input-dark colorBorde"
            maxlength="8"
            v-model="codigoSunatBarras"
            @change="getReceiverItem(2)"
          ></b-form-input>
          <b-form-input
            v-else
            :placeholder="placeholdercodigo"
            class="form-control input-requerido input-dark colorBorde"
            maxlength="8"
            v-model="codigoSunatBarras"
            @change="getReceiversBarCodeSunat"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col cols="12" sm="12" md="12" lg="12" xl="7">
        <b-input-group>
          <b-form-input
            placeholder="Descripcion (*)"
            maxlength="500"
            v-model="descripcion"
            @keydown="tecla"
            :disabled="this.$store.getters.getcomprobante==7 && this.dataitem.idReceptor.length == 0"
            class="form-control input-dark colorBorde"
            type="text"
          ></b-form-input>
          <b-input-group-text class="colorBorde" slot="append">
            <b-button 
              variant="warning" 
              size="sm" 
              class="sinresultados" 
              @click="cerrarresultados">
              <i class="fa fa-times"></i>
            </b-button>
            <b-button
              :disabled="this.dataitem.idReceptor.length == ''"
              variant="primary"
              size="sm"
              v-b-modal.productosproveedor
              class="sinresultados ml-2"
              @click="listProductProvider"
            >
              <i class="fa fa-list"></i>
            </b-button>
          </b-input-group-text>
        </b-input-group>
        <template v-if="cargandoDescription">
          <b-list-group-item>
            Buscando
            <i class="fa fa-spin fa-spinner"></i>
          </b-list-group-item>
        </template>
        <template v-else> 
          <b-list-group v-if="listades" class="searcher-field">
            <table v-if="listaDescription.length > 0" class="searcher-result3">
                  <tr class="centrarTitulo tablaborde">
                    <th style="width:50%;">Productos</th>
                    <th style="width:8%;">Precio</th>
                    <th style="width:5%;">Costo</th>
                    <th style="width:7%;">Stock</th>
                    <th style="width:10%;">Código</th>
                  </tr>
                </table>
              <template v-for="(item, index) in opcionesOrdenadas">
                <table  
                  @click="setReceiverItem(item)" 
                  class="searcher-result2" 
                  :key="index">  
                  <tr>
                    <td style="width:50%;" class="tablaborde ">{{item.descripcion.toUpperCase()}}</td>
                    <td style="width:8%;" class="tablaborde centrarTitulo">{{item.precioUnitario}}</td>
                    <td style="width:5%;color:red" class="tablaborde centrarTitulo">{{item.precioCosto}}</td>
                    <td style="width:7%;" class="tablaborde centrarTitulo">{{item.stock}}</td>
                    <td style="width:10%;" class="tablaborde centrarTitulo">{{item.codigo}}</td>
                  </tr>
                </table>
              </template>
          </b-list-group>
        </template>
        <!-- OTRA BUSQUEDA -->
        <b-list-group v-if="nuevaBusqueda" class="searcher-field">
          <table v-if="nuevaBusquedaAlmacenada.length > 0" class="searcher-result3">
                <tr class="centrarTitulo tablaborde">
                  <th style="width:50%;">Productos</th>
                  <th style="width:8%;">Precio</th>
                  <th style="width:5%;">Costo</th>
                  <th style="width:7%;">Stock</th>
                  <th style="width:10%;">Código</th>
                </tr>
              </table>
            <template v-if="filterItem(item)" v-for="(item, index)  in opcionesOrdenadas" >
                  <table @click="setReceiverDescription2(item)" 
                  class="searcher-result2" :key="index">  
                    <tr >
                      <td style="width:50%;" class="tablaborde ">{{item.descripcion.toUpperCase()}}</td>
                      <td style="width:8%;" class="tablaborde centrarTitulo">{{item.precioUnitario}}</td>
                      <td style="width:5%;color:red" class="tablaborde centrarTitulo">{{item.precioCosto}}</td>
                      <td style="width:7%;" class="tablaborde centrarTitulo">{{item.stock}}</td>
                      <td style="width:10%;" class="tablaborde centrarTitulo">{{item.codigo}}</td>
                    </tr>
                  </table>
              </template>
        </b-list-group>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col cols="12" sm="12" md="12" lg="12" xl="9">
        <b-row>
          <b-col cols="12" sm="4" md="3" lg="2" xl="2">
            <input
              :disabled="dataitem.freesale == 0"
              v-if="!vunitario"
              v-model="precioVentaUnitario"
              class="form-control input-requerido input-dark colorBorde"
              placeholder="Precio Unitario (con IGV)"
              @keyup.enter="enter()"
              required
            />
            <b-form-input
              v-else
              v-model="precioVentaUnitario"
              class="form-control colorBorde"
              placeholder="Precio Unitario (con IGV)"
              required
              disabled
            />
            <small v-if="checkprecioventaunitario" class="form-text text-muted">
              <span class="text-danger">{{ responsecheckprecioventaunitario }}</span>
            </small>
          </b-col>
          <b-col cols="12" sm="4" md="3" lg="2" xl="2">
            <input
              v-if="vunitario"
              @keyup.enter="enter()"
              type="text"
              min="0.0"
              step="0.01"
              v-model.number="valorUnitario"
              class="form-control input-placedark input-dark colorBorde"
              placeholder="Valor Unitario (Sin IGV)"
              required
            />
            <b-form-input
              v-else
              type="number"
              min="0.0"
              step="0.01"
              v-model="valorUnitario"
              class="form-control input-placedark input-dark colorBorde"
              placeholder="Valor Unitario (Sin IGV)"
              required
              disabled
            />
            <small v-if="checkvalorunitario" class="form-text text-muted">
              <span class="text-danger">{{ responsecheckvalorunitario }}</span>
            </small>
          </b-col>
          <b-col cols="12" sm="4" md="3" lg="3" xl="3">
            <b-row>
              <b-col cols="12" sm="4" md="4" lg="4" xl="4" class="botondescuento">
                <b-form-checkbox
                  :disabled="dataitem.freesale == 0"
                  v-model="descuento"
                >Dscto</b-form-checkbox>
              </b-col>
              <b-col cols="12" sm="8" md="8" lg="8" xl="8" v-if="!descuento">
                <b-row>
                  <b-col cols="12" class="checkdescuentoitem">
                    <b-input-group>
                      <input
                        :disabled="dataitem.freesale == 0"
                        @keyup.enter="enter()"
                        v-model="descuentoItemMonto"
                        class="form-control input-requerido input-dark colorBorde"
                      />
                      <b-input-group-text slot="prepend" class="colorBorde">
                      S/
                    </b-input-group-text>
                    </b-input-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" sm="8" md="8" lg="8" xl="8" v-else>
                <b-row>
                  <b-col cols="12" class="checkdescuentoitem">
                    <b-input-group>
                      <input
                        @keyup.enter="enter()"
                        v-model="descuentoItemPorcentaje"
                        class="form-control input-requerido input-dark colorBorde"
                      />
                      <b-input-group-text slot="append" class="colorBorde">
                        %
                      </b-input-group-text>
                    </b-input-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" sm="6" md="3" lg="2" xl="2">
            <b-form-input v-if="tipoOperacion == '0200'" disabled value="Exportación"></b-form-input>
            <select
              v-else
              class="custom-select mr-sm-2 input-placedark input-dark colorBorde"
              v-model="especificacionIgv"
              :disabled="dataitem.freesale == 0"
            >
              <option
                :value="afec.id"
                v-for="afec in listaafectacion"
                v-bind:key="afec.id"
              >{{ afec.descripcion }}</option>
            </select>
          </b-col>
          <b-col v-if="!ventaGratuita" cols="12" sm="6" md="3" lg="3" xl="3">
            <b-form-input class="colorBorde" disabled value="Operación Onerosa"></b-form-input>
          </b-col>
          <b-col v-else cols="12" sm="6" md="3" lg="3" xl="3">
            <b-form-input 
              v-if="tipoOperacion == '0200'" 
              disabled value="Bienes">
            </b-form-input>
            <select
              v-else
              class="custom-select mr-sm-2 input-placedark input-dark colorBorde"
              v-model="especificacion"
            >
              <option
                :value="espec"
                v-for="espec in Especificacion"
                v-bind:key="espec.id"
              >{{ espec.descripcion }}</option>
            </select>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mt-3" cols="3">
            <b-form-input v-model="observacionItem" class="colorBorde" placeholder="Observacion del Producto"></b-form-input>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col cols="12" sm="6" md="3" lg="3" xl="12"></b-col>
        </b-row>
      </b-col>
      <b-col cols="12" sm="12" md="12" lg="12" xl="3">
        <b-card class="adicionalesOperacionItem">
          <span class="titulo-opitem">
            <strong>Operaciones Adicionales</strong>
          </span>
          <br />
          <b-form-checkbox v-model="vunitario">Usar valor unitario</b-form-checkbox>
          <b-form-checkbox v-model="servicio">Servicio</b-form-checkbox>
          <b-form-checkbox v-model="vbarras">C. Barras</b-form-checkbox>
          <b-form-checkbox v-model="ventaGratuita" :disabled="disabledGratuita">Venta Gratuita</b-form-checkbox>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" sm="12" md="12" lg="12" xl="6" class="text-center  buttonagregar2 ">
        <template v-if="!setUpdateItem">
          <button
            class="btn btn-primary btnagregarstyle"
            v-if="validateFields()"
            @click="addItem()"
          >
            <i class="fa fa-plus"></i> Agregar
          </button>
          <button class="btn btn-secondary btnagregarstyle" disabled v-else>
            <i class="fa fa-plus"></i> Agregar
          </button>
        </template>
        <template v-else>
          <button class="btn btn-warning" @click="executeUpdate()">
            <i class="fa fa-plus"></i> Actualizar
          </button>
        </template>
      </b-col>
      <b-col style="margin-left:100px" cols="1" class="buttonagregar"> 
        <div class="upload-btn-wrapper">
           <b-button class="estilo"><i class="fas fa-upload"></i> Items</b-button>
           <input  type="file" @change="onChange" name="myfile" />
        </div>
        <xlsx-read :file="file">                       
          <xlsx-json>
            <template #default="{collection}">
              <div style="display:none;">
                {{ coleccion=collection }}
              </div>
              </template>
          </xlsx-json>
        </xlsx-read>
      </b-col>
      <import :item="item" :igvGlobal="igvGlobal" :itemsEX="itemsEX" :action="action" @totalitems="totalitems"></import>
    </b-row>
    <br />
    <b-modal id="productosproveedor" size="xl" cancel-title="Cerrar" v-model="productosproveedor">
      <template slot="modal-title">
        Se Agregaron
        <b class="text-danger">{{ nroitemsprov }}</b> item(s) a la lista
      </template>
      <template v-if="loadproductos">
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Cargando...</strong>
        </div>
      </template>
      <template v-else>
        <b-table
          striped
          hover
          small
          responsive
          outlined
          :per-page="limite"
          :items="listProduct"
          :fields="products_fields"
          :busy="isBusy"
        >
          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Cargando...</strong>
          </div>
          <template slot="cantidad" slot-scope="row">
            <!-- <b-row>
            <b-col xl="6">-->
            <b-form-input v-model="row.item.cantidad"></b-form-input>
            <!-- </b-col>
            </b-row>-->
          </template>
          <template slot="acciones" slot-scope="row">
            <b-button size="sm" class="btn btn-warning" @click="addProductoProveedor(row.item)">
              <i class="fa fa-plus"></i>
            </b-button>
          </template>
        </b-table>
      </template>
      <div class="row">
        <div class="col-md-6">
          <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
        </div>
        <div class="col-md-6">
          <div class="float-right">
            <b-pagination
              size="sm"
              :total-rows="total"
              v-model="currentPage"
              @input="listProductProvider"
              :per-page="limite"
            ></b-pagination>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  

<script>
import axios from "axios";
import { UnidadMedida } from "@/shared/utils";
import { TipoAfectacion } from "@/shared/utils";
import { EspecificacionIgvTipo1 } from "@/shared/utils";
import { EspecificacionIgvTipo2 } from "@/shared/utils";
import { EspecificacionIgvTipo3 } from "@/shared/utils";
import { XlsxRead, XlsxJson, XlsxTable } from "vue-xlsx/dist/vue-xlsx.es.js"
import Import from '@/components/comunes/pImportItems'
export default {
  name: "Items",
  components: {
    XlsxRead,
    XlsxJson,
    XlsxTable,
    Import
  },
  props: ["dataitem","igvGlobal"],
  data: () => {
    return {
      timer:null,
      nuevaBusqueda:false,
      nuevaBusquedaAlmacenada:[],
      quantityerror: true,
      checkcantidad: false,
      responsecheckcantidad: "",
      unidadMedidaCantidad: "NIU",
      unidades: UnidadMedida,
      codigoProducto: "",
      idProducto: "-",
      cargandoDescription: false,
      listaReceptores: [],
      listaDescription: [],
      setUpdateItem: false,
      tipoOperacion: "0101",
      codigoSunatBarras: "",
      placeholdercodigo: "C. Sunat",
      cantidad: 1,
      descripcion: "",
      precioVentaUnitario: "",
      valorUnitario: "",
      listades: true,
      nodescription: false,
      noProductCode: false,
      noBarCodeSunat: false,
      listarecProductCode: false,
      vunitario: false,
      vbarras: false,
      servicio: false,
      descuento: false,
      ventaGratuita: false,
      checkprecioventaunitario: false,
      checkvalorunitario: false,
      descuentoGlobalMonto: "",
      descuentoGlobalPorcentaje: "",
      descuentoItemMonto: "",
      descuentoItemPorcentaje: "",
      checkedDsctoGlobal: true,
      listaafectacion: TipoAfectacion,
      EspecificacionIgv: EspecificacionIgvTipo1,
      EspecificacionIgv2: EspecificacionIgvTipo2,
      EspecificacionIgv3: EspecificacionIgvTipo3,
      Especificacion: [],
      especificacionIgv: "01",
      disabledGratuita: false,
      especificacion: {
        codigo: "10",
        descripcion: "Operacion onerosa",
        codigoTributo: "1000"
      },
      setIndex: -1,
      items: [],
      items_fields: [
        { key: "cantidad", label: "Cantidad", sortable: true },
        { key: "descripcion", label: "Descripción", sortable: true },
        { key: "valorUnitarioVista", label: "Valor Unitario", sortable: true },
        { key: "descuento", label: "Descuento", sortable: true },
        { key: "montoAfectacionIgv", label: "Igv", sortable: true },
        { key: "valorVentaVista", label: "Valor Total", sortable: true },
        { key: "acciones", label: "Acciones", sortable: true }
      ],
      // sinresultados: false,
      itemsTransicion: [],
      idReceptor: "",
      tipobusqueda: 0, // 0: Busqueda normal; 1: busqueda para OC
      comprobante: 0,
      listProduct: [],
      products_fields: [
        { key: "codigo", label: "Código", sortable: true },
        { key: "unidadMedida", label: "Unidad Medida", sortable: true },
        { key: "descripcion", label: "Descripcion", sortable: true },
        { key: "tipoAfectacionIgv", label: "Afectacion", sortable: true },
        { key: "precioUnitario", label: "Precio Unitario", sortable: true },
        { key: "cantidad", label: "Cantidad", sortable: true },
        { key: "acciones", label: "Acciones", sortable: true }
      ],
      isBusy: false,
      loadproductos: false,
      currentPage: 1,
      limite: 10,
      total: 0.0,
      desde: 0.0,
      hasta: 0.0,
      productosproveedor: false,
      // setcantidad: 1,
      nroitemsprov: 0,
      montoValorUnitario2:'',
      montoIgvGlobal:'',
      file: null,
      coleccion:[],
      itemsEX:[],
      item:[],
      action: {
        i: false,
        reset: false
      },
      observacionItem:'',
      actualizado:0,
      inafecto:'',
      unoDieciocho:1.18,
      ceroDieciocho:0.18,
      dieciocho:18,
      // unoUno:1.1,
      // ceroUno:0.1,
      // diez:10,
      unoUno:1.105,
      ceroUno:0.105,
      diez:10.5,
      opcionesOrdenadas: [], // Inicialmente vacío
      porCodigo:[], //busca producto x codigo
    };
  },
  mounted() {
    this.tipoComprobante(), this.clear();
  },
  updated() {
    this.tipoComprobante();
  },
  watch: {
    coleccion:function(){
        if(this.coleccion !=null){                   
            this.itemsEX = this.coleccion
            this.action.i = true                  
        }else{
                
        }
    },
    "dataitem.estado": function() {
      this.idReceptor = this.dataitem.idReceptor;
      this.dataitem.ordencompra == 0
        ? (this.tipobusqueda = 0)
        : (this.tipobusqueda = 1);
      if (this.dataitem.tipo === 1) {
        // Actualizar
        this.updateItem();
      } else if (this.dataitem.tipo === 2) {
        // Borrar
        this.deleteItem(this.dataitem.index);
      }
    },
    cantidad: function() {
      if (this.cantidad < 0) {
        this.checkcantidad = true;
        this.responsecheckcantidad = "Cantidad debe ser mayor a 0";
      } else {
        this.checkcantidad = false;
        this.responsecheckcantidad = "";
      }
    },
    servicio: function(val) {
      if (this.servicio) {
        this.unidadMedidaCantidad = "ZZ";
      } else {
        this.unidadMedidaCantidad = "NIU";
      }
    },
    tipoOperacion: function() {
      // Operaciones sujetas a detraccion
      if (this.tipoOperacion == "1001" || this.tipoOperacion == "1002") {
        this.showAccountDetraction();
        this.detraccionCarga = false;
      } else if (this.tipoOperacion == "0200") {
        (this.receptor.tipo = "0"), (this.disabledGratuita = true);
        this.detraccionCarga = false;
      } else if (this.tipoOperacion == "1004") {
        this.showAccountDetraction();
        this.detraccionCarga = true;
        this.items = [];
      } else {
        (this.receptor.tipo = "6"), (this.disabledGratuita = false);
        this.detraccionCarga = false;
      }
    },
    codigoSunatBarras: function() {
      if (this.codigoSunatBarras != null) {
        if (this.codigoSunatBarras.length === 8) {
          this.validateExportacion = true;
        } else {
          this.validateExportacion = false;
        }
      }
    },
    vbarras: function() {
      if (this.vbarras) {
        this.placeholdercodigo = "C. Barras";
      } else {
        this.placeholdercodigo = "C. Sunat";
      }
    },
    precioVentaUnitario: function() {
      if (this.precioVentaUnitario < 0) {
        this.checkprecioventaunitario = true;
        this.responsecheckprecioventaunitario = "Cantidad debe ser mayor a 0";
      } else {
        this.checkprecioventaunitario = false;
        this.responsecheckprecioventaunitario = "";
      }
      if (this.especificacionIgv == "01" && this.tipoOperacion != "0200") {
        if (!this.vunitario) {
          this.valorUnitario = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
        }
        else if(this.valorUnitario > 0){
         this.precioVentaUnitario = this.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
        }  
      } else if (
        this.especificacionIgv == "02" ||
        this.especificacionIgv == "03" ||
        this.tipoOperacion == "0200"
      ) {
        this.valorUnitario = this.precioVentaUnitario;
      }
    },
    valorUnitario: function() {
      if (this.valorUnitario < 0) {
        this.checkvalorunitario = true;
        this.responsecheckvalorunitario = "Cantidad debe ser mayor a 0";
      } else {
        this.checkvalorunitario = false;
        this.responsecheckvalorunitario = "";
      }
      if (this.vunitario) {
        if (this.especificacionIgv == "01" && this.tipoOperacion != "0200") {
          this.precioVentaUnitario = this.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
        } else if (
          this.especificacionIgv == "02" ||
          this.especificacionIgv == "03" ||
          this.tipoOperacion == "0200"
        ) {
          this.precioVentaUnitario = this.valorUnitario;
        }
      }
    },
    especificacionIgv: function() {
      if (!this.ventaGratuita) {
        this.especificacion.codigo = "10";
        this.especificacion.descripcion = "Operacion onerosa";
        this.especificacion.codigoTributo = "1000";
        this.calcItem();
      } else {
        this.especificacion.codigo = "21";
        this.especificacion.descripcion = "Exonerado - Transferencia gratuita";
        this.especificacion.codigoTributo = "9996";
        this.calcItemGratuitos();
      }
    },
    ventaGratuita: function() {
      if (!this.ventaGratuita) {
        this.especificacion.codigo = "10";
        this.especificacion.descripcion = "Exonerado - Transferencia gratuita";
        this.especificacion.codigoTributo = "1000";
      } else {
        this.especificacion.codigo = "15";
        this.especificacion.descripcion = "Grabado - Bonificaciones";
        this.especificacion.codigoTributo = "9996";
      }
    },
    descripcion: function() {
      if (this.descripcion.length > 500) {
        this.checkdescripcion = true;
        this.responsecheckdescripcion =
          "Alfanumerico de maximo 500 caracteres ";
      } else if (this.descripcion.length == 0) {
        // this.sinresultados = false,
        this.cargandoDescription = false;
        (this.listades = false),
          (this.listaDescription = []),
          (this.quantityerror = true);
      } else {
        this.checkdescripcion = false;
        this.responsecheckdescripcion = "";
      }
    }
  },
  methods: {
    onChange(event) {
        this.file = event.target.files ? event.target.files[0] : null;
    },
    totalitems(value){
        this.items = value
        this.action.i = false
        this.insertItem(this.items)
    },
    clear: function() {
      let itemBlank = [];
      (this.items = []), this.$store.commit("setitems", itemBlank);
    },
    addProductoProveedor: function(item) {
      this.cantidad = item.cantidad;
      this.unidadMedidaCantidad = item.unidadMedida;
      this.codigoProducto = item.codigo;
      this.codigoSunatBarras = item.codigoProductoSunat;
      this.descripcion = item.descripcion;
      this.precioVentaUnitario = item.precioUnitario;
      this.tipoAfectacionIgv = item.tipoAfectacionIgv;
      this.nroitemsprov =
        parseFloat(this.nroitemsprov) + parseFloat(this.cantidad);
      this.setPrecioVentaUnitario();
      this.addItem();
      item.cantidad = "";
    },
    setPrecioVentaUnitario: function() {
      if (this.precioVentaUnitario < 0) {
        this.checkprecioventaunitario = true;
        this.responsecheckprecioventaunitario = "Cantidad debe ser mayor a 0";
      } else {
        this.checkprecioventaunitario = false;
        this.responsecheckprecioventaunitario = "";
      }
      if (this.especificacionIgv == "01" && this.tipoOperacion != "0200") {
        if (!this.vunitario) {
          this.valorUnitario = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
        }
      } else if (
        this.especificacionIgv == "02" ||
        this.especificacionIgv == "03" ||
        this.tipoOperacion == "0200"
      ) {
        this.valorUnitario = this.precioVentaUnitario;
      }
    },
    listProductProvider: function() {
      this.loadproductos = true;
      axios
        .post(process.env.VUE_APP_API_URL + "productos/oc/lista", {
          token: this.$store.getters.userToken,
          page: this.currentPage,
          order: "desc",
          limit: this.limite,
          idreceptor: this.dataitem.idReceptor
        })
        .then(
          response => (
            (this.loadproductos = false),
            (this.listProduct = response.data.producto.data),
            (this.total = response.data.producto.total),
            (this.desde = response.data.producto.from),
            (this.hasta = response.data.producto.to),
            this.listProduct.forEach( element => {
              element.cantidad = 1
            })
          )
        )
        .catch(error => (this.loadproductos = false));
    },
    tipoComprobante: function() {
      (this.comprobante = this.$store.getters.getcomprobante),
      (this.items = this.$store.getters.getitems);
    },
    insertItem: function(value) {
      this.$emit("captureitem", this.items);
    },
    enter: function() {
      if (this.validateFields()) {
        this.addItem();
      }
    },
    validateFields: function() {
      let validateDetraccion = false;
      let itemsDetraccion = false;
      let itemsGenerales = false;
      if (this.tipoOperacion == "1004" && this.itemsDetraccionCheck) {
        itemsDetraccion = true;
      } else {
        itemsDetraccion = false;
      }
      if (
        this.cantidad != "" &&
        this.descripcion != "" &&
        this.precioVentaUnitario !== "" &&
        this.valorUnitario !=="" && this.valorUnitario > 0
      ) {
        itemsGenerales = true;
      } else {
        itemsGenerales = false;
      }
      // Caso detraccion transporte de carga "tipoOperacion == '1004'"
      if (itemsDetraccion && itemsGenerales && this.tipoOperacion == "1004") {
        return true;
      }
      if (
        this.validateExportacion &&
        itemsGenerales &&
        this.tipoOperacion == "0200"
      ) {
        // Caso emision de exportacion
        return true;
      }
      if (
        itemsGenerales &&
        (this.tipoOperacion == "0101" ||
          this.tipoOperacion == "0112" ||
          this.tipoOperacion == "0113" ||
          this.tipoOperacion == "1001" ||
          this.tipoOperacion == "1002" ||
          this.tipoOperacion == "1004")
      ) {
        // Caso emision comun
        return true;
      } else {
        return false;
      }
    },
    cerrarresultados: function() {
      (this.listaDescription = []),
        (this.listades = false),
        (this.cargandoDescription = false),
        (this.quantityerror = true);
    },
    setReceiverItem: function(item) {
      // this.precioVentaUnitario; //ejecuta el watch para activar la funcion en caso seleccionan V.Unitario

      this.descuentaStock = item.descuentaStock
      this.codigoProducto = item.codigo;
      this.descripcion = item.descripcion;
      this.codigoSunatBarras = item.codigoProductoSunat;
      this.precioVentaUnitario = item.precioUnitario;
      this.unidadMedidaCantidad = item.unidadMedida;
      if (item.tipoAfectacionIgv == "") {
        this.especificacionIgv = "01";
      } else {
        this.especificacionIgv = item.tipoAfectacionIgv;
      }
        if (item.idProducto == "") {
         this.idProducto = "-"
      } else {
         this.idProducto = item.idProducto
      }
      this.listades = false;
      this.listaDescription = [];
      this.cargandoDescription = false;
    },
    setReceiverDescription2(item){
        (this.idProducto = item.idProducto),
        (this.codigoProducto = item.codigo),
        (this.descripcion = item.descripcion),
        (this.codigoSunatBarras = item.codigoProductoSunat),
        (this.precioVentaUnitario = item.precioUnitario);
        this.otrosCargosProducto = item.otrosCargos;
        this.unidadMedidaCantidad = item.unidadMedida;
        if (item.tipoAfectacionIgv == "") {
          this.especificacionIgv = "01";
        } else {
          this.especificacionIgv = item.tipoAfectacionIgv;
        }
        (this.listades = false), (this.listaDescription = []);
        if(item.isc !='' && item.isc != null){
          this.isc = true;
          this.selectedISC = item.isc.tipoISC;
          if(item.isc.tipoISC == 3){
            this.montoISC = item.isc.valorReferencial
            this.porcentajeISC = item.isc.valorISC
          }else{
            this.montoISC = item.isc.valorISC
          }
        }
      },
      filterItem(item){
        return item.descripcion.toLocaleLowerCase().indexOf(this.descripcion.toLocaleLowerCase())>=0
      },
    tecla(event){
        if (event.keyCode === 13) {
          this.getReceiverItem(3);
          return;
        }
          if (this.timer) {
            clearTimeout(this.timer);
        }
          this.timer = setTimeout(() => {this.getReceiverItem(3);}, 1000);
      },
    getReceiverItem: function(tipo) {
      let arrayNuevo =[]
      this.listaDescription = [];
      if(this.descripcion.length >=3 || this.codigoProducto.length >=3 ){
        arrayNuevo = this.$store.getters.getTotalItems.filter(item => {
          // Verificar si la descripción del producto contiene el texto de búsqueda
          if(this.descripcion!=''){
            if(item && item.descripcion){
              return item.descripcion.toLowerCase().includes(this.descripcion.toLowerCase());
            }   
          }else if(this.codigoProducto!=''){
            if(item && item.codigo){
              return item.codigo.toLowerCase().includes(this.codigoProducto.toLowerCase());
            }
          } 
        });
        this.sinresultados = true, 
                this.cargandoDescription = true,
                this.listades = true,

                this.listaDescription = arrayNuevo,
                this.cargandoDescription = false,
                this.sinresultados = false,
                this.cargandoreceptor = false,
                this.ordenarOpciones(this.listaDescription)
      }else{
        arrayNuevo = [];
      }
      if (arrayNuevo.length === 0 && this.descripcion.length >= 4) {
                this.$snotify.warning('PRODUCTO NO ENCONTRADO')
            } 
    },
      ordenarOpciones: function(item) {
        this.opcionesOrdenadas = item.slice().sort((a, b) => {
                const lowerCaseDescripcionA = a.descripcion.toLowerCase();
                const lowerCaseDescripcionB = b.descripcion.toLowerCase();
                const lowerCaseSearch = this.descripcion.toLowerCase();

                const indexA = lowerCaseDescripcionA.indexOf(lowerCaseSearch);
                const indexB = lowerCaseDescripcionB.indexOf(lowerCaseSearch);
                // Si ambos tienen la misma cantidad de caracteres coincidentes,
                // ordenar por el índice en la descripción
                if (indexA === indexB) {
                    return indexA - indexB;
                }
                // Si tienen diferentes cantidades de caracteres coincidentes,
                // ordenar por la diferencia en la cantidad de caracteres
                if (indexA === 0) {
                    return -1; // a aparece primero
                } else if (indexB === 0) {
                    return 1; // b aparece primero
                } else if (indexA > 0 && indexB > 0) {
                    // Si ambos están después de la primera posición,
                    // ordenar por la posición
                    return indexA - indexB;
                } else {
                    // Si uno de ellos no contiene el término de búsqueda en la descripción,
                    // el que contiene la coincidencia aparece primero
                    return indexA < 0 ? 1 : -1;
                }
            });
      },
    checkError: function(data) {
      this.cargandoDescription = false;
      if (data.success === 0) {
        this.listades = false;
        this.quantityerror = false;
        this.listaDescription = [];
        // this.comprobante == 7 ? this.$snotify.warning(data.msj+' '+'Consulte a su proveedor por su lista de Productos', 'Atención'): this.$snotify.warning(data.msj, 'Atención')
      } else if (data.success === 1) {
        this.listaDescription = data.response;
        (this.quantityerror = true), (this.listades = true);
      }
    },
    initIgv: function() {
      if (this.especificacionIgv === "01") {
        this.Especificacion = this.EspecificacionIgv;
      } else if (this.especificacionIgv === "02") {
        this.Especificacion = this.EspecificacionIgv2;
      } else if (this.especificacionIgv === "03") {
        this.Especificacion = this.EspecificacionIgv3;
      }
    },
    addItem: function() {
      let item = {

        valorVentaSinAfectar: 0,
        tipoAfectacionIgv: 0,
        codigoTributo: "",
        codigoProductoSunat: "",
        unidadMedidaCantidad: "",
        cantidad: "",
        descripcion: "",
        observaciones:"",
        valorUnitario: "",
        tipoPrecioVentaUnitario: "",
        descuento: "",
        porcentajeDescuento: "",
        baseAfectacionIgv: "",
        valorUnitarioVista: "",
        valorVenta: "",
        valorVentaVista: "",
        porcentajeImpuesto: "",
        montoAfectacionIgv: "",
        montoTotalImpuestosItem: "",
        precioVentaUnitario: "",
        idProducto:"-",
        descuentoStock:'',
        adicional:{
            indicardorDsct:'',
            dsctSoles:'',
            dsctPorcentaje:'',
            precioVentaUni:'',
        },
        cargosDescuentosItem:[{}]
      };
      if(this.setIndex != -1){
        if(this.actualizado >= 0){    
          ++this.actualizado
          item.actualizado = this.actualizado;
        }
      }else{
          item.actualizado = this.actualizado;
      }
    
      item.observaciones = this.observacionItem
      item.valorVentaSinAfectar = this.valorUnitario * this.cantidad;
      item.tipoAfectacionIgv = this.especificacion.codigo;
      if (this.codigoProducto != "") {
        item.codigoProducto = this.codigoProducto;
      }
      if (!this.vbarras) {
        if (this.codigoSunatBarras != null) {
          item.codigoProductoSunat = this.codigoSunatBarras;
        } else {
          delete item.codigoProductoSunat;
        }
      } else {
        if (this.codigoProductoGs1 != "") {
          item.codigoProductoGs1 = this.codigoProductoGs1;
        } else {
          delete item.codigoProductoGs1;
        }
      }
      if(this.descuentaStock == '1'){
        item.descuentaStock = 1
      }else if(this.descuentaStock =='2'){
        item.descuentaStock = 2
      }
      
      item.idProducto = this.idProducto;
      item.unidadMedidaCantidad = this.unidadMedidaCantidad;
      item.cantidad = parseFloat(this.cantidad);
      item.descripcion = this.descripcion;
      item.valorUnitario = parseFloat(this.valorUnitario);
      if (
        this.especificacion.codigo == "10" ||
        this.especificacion.codigo == "20" ||
        this.especificacion.codigo == "30"
      ) {
        item.tipoPrecioVentaUnitario = "01";
      } else {
        item.tipoPrecioVentaUnitario = "02";
      }
      if (this.descuentoItemMonto != "" && this.especificacionIgv == "01") {
        item.adicional.indicardorDsct = '01'
        item.adicional.dsctSoles = parseFloat(this.descuentoItemMonto)
        item.descuento = parseFloat(this.descuentoItemMonto / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(10); //1.18
        item.porcentajeDescuento =
          parseFloat(this.descuentoItemMonto / (this.$store.state.igv == 18 ? 1.18 : 1.105)) / item.valorVentaSinAfectar; //1.18
      } else if (
        this.descuentoItemMonto != "" &&
        (this.especificacionIgv == "02" || this.especificacionIgv == "03")
      ) {
        item.adicional.dsctSoles = parseFloat(this.descuentoItemMonto)
        item.adicional.indicardorDsct = '01'
        item.descuento = parseFloat(this.descuentoItemMonto).toFixed(10);
        item.porcentajeDescuento =
          parseFloat(this.descuentoItemMonto) / item.valorVentaSinAfectar;
        this.inafecto = (item.valorVentaSinAfectar  - this.descuentoItemMonto)/item.cantidad;
      } else if (this.descuentoItemPorcentaje != "") {
        item.adicional.indicardorDsct = '02'
        item.adicional.dsctPorcentaje = parseFloat(this.descuentoItemPorcentaje)
        item.descuento = (
          (this.descuentoItemPorcentaje / 100) *
          item.valorUnitario *
          item.cantidad
        ).toFixed(10);
        item.porcentajeDescuento = this.descuentoItemPorcentaje / 100;
      } else {
        item.descuento = parseFloat(0.0);
        item.porcentajeDescuento = parseFloat(0.0);
        // delete item.adicional.descuentoItem
        delete item.cargosDescuentosItem;
        item.cargosDescuentosItem = []
      }
      if (item.descuento == 0) {
        item.baseAfectacionIgv = parseFloat(item.valorUnitario * item.cantidad);
        delete item.cargosDescuentosItem;
        item.cargosDescuentosItem = []
      } else {
        item.baseAfectacionIgv = parseFloat(
          item.valorUnitario * item.cantidad - item.descuento
        );
      }
      // Bloque de las gratuitas
      if (this.ventaGratuita) {
        item.valorUnitario = parseFloat(0.0);
        item.valorUnitarioVista = parseFloat(this.valorUnitario).toFixed(10);
        item.valorVenta = item.baseAfectacionIgv;
        item.valorVentaVista = (0.0).toFixed(10);
      } else {
        item.valorUnitario = parseFloat(this.valorUnitario);
        item.valorUnitarioVista = item.valorUnitario;
        item.valorVenta = item.baseAfectacionIgv;
        item.valorVentaVista = item.valorVenta;
      }
      if (this.especificacionIgv == "01") {
        item.montoAfectacionIgv = item.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
        item.montoTotalImpuestosItem = parseFloat(item.montoAfectacionIgv);
      } else if (
        this.especificacionIgv == "02" ||
        this.especificacionIgv == "03"
      ) {
        item.montoAfectacionIgv = parseFloat(0.0);
        item.montoTotalImpuestosItem = parseFloat(item.montoAfectacionIgv);
      }
      if (this.tipoOperacion == "0200") {
        (item.codigoTributo = "9995"),
          (item.tipoAfectacionIgv = "40"),
          (item.montoAfectacionIgv = parseFloat(0.0));
        item.montoTotalImpuestosItem = parseFloat(item.montoAfectacionIgv);
      } else {
        item.codigoTributo = this.especificacion.codigoTributo;
      }
      // item.tipoAfectacionIgv == '20' || item.tipoAfectacionIgv == '30' || item.tipoAfectacionIgv == '40'
      if (
        item.tipoAfectacionIgv == "20" ||
        item.tipoAfectacionIgv == "21" ||
        item.tipoAfectacionIgv == "30" ||
        item.tipoAfectacionIgv == "31" ||
        item.tipoAfectacionIgv == "32" ||
        item.tipoAfectacionIgv == "33" ||
        item.tipoAfectacionIgv == "34" ||
        item.tipoAfectacionIgv == "35" ||
        item.tipoAfectacionIgv == "36" ||
        item.tipoAfectacionIgv == "37" ||
        item.tipoAfectacionIgv == "40"
      ) {
        item.porcentajeImpuesto = 0;
      } else if (
        item.tipoAfectacionIgv == "10" ||
        item.tipoAfectacionIgv == "11" ||
        item.tipoAfectacionIgv == "12" ||
        item.tipoAfectacionIgv == "13" ||
        item.tipoAfectacionIgv == "14" ||
        item.tipoAfectacionIgv == "15" ||
        item.tipoAfectacionIgv == "16"
      ) {
        item.porcentajeImpuesto = (this.$store.state.igv == 18 ? 18 : 10.5); //18
      }     

      item.adicional.precioVentaUni = parseFloat(this.precioVentaUnitario)
      item.precioVentaUnitario = parseFloat(this.precioVentaUnitario);
     if(item.descuento !=0){
          if(this.descuentoItemMonto != "" &&(this.especificacionIgv == "02" || this.especificacionIgv == "03")){
            item.precioVentaUnitario = this.inafecto; 
            item.cargosDescuentosItem[0].indicador= "descuento";
            (item.cargosDescuentosItem[0].codigoCargoDescuento= "00");
            (item.cargosDescuentosItem[0].factorCargoDescuento = parseFloat(parseFloat(item.porcentajeDescuento).toFixed(5)));
            item.cargosDescuentosItem[0].montoCargoDescuento = parseFloat(parseFloat(item.descuento).toFixed(2));
            item.cargosDescuentosItem[0].baseCargoDescuento = parseFloat(parseFloat(item.valorVentaSinAfectar).toFixed(2));
          }else{
          if(this.cantidad >= 0){
            this.montoValorUnitario2 = ( item.valorUnitario - (item.descuento/item.cantidad)); 
            this.montoIgvGlobal = this.montoValorUnitario2 *(this.$store.state.igv == 18 ? 0.18 : 0.105); // 0.18
            item.precioVentaUnitario = this.montoValorUnitario2 + this.montoIgvGlobal;
            item.cargosDescuentosItem[0].indicador= "descuento";
            (item.cargosDescuentosItem[0].codigoCargoDescuento= "00");
            (item.cargosDescuentosItem[0].factorCargoDescuento = parseFloat(parseFloat(item.porcentajeDescuento).toFixed(5)));
            item.cargosDescuentosItem[0].montoCargoDescuento = parseFloat(parseFloat(item.descuento).toFixed(2));
            item.cargosDescuentosItem[0].baseCargoDescuento = parseFloat(parseFloat(item.valorVentaSinAfectar).toFixed(2));
          }else{
            item.precioVentaUnitario = item.baseAfectacionIgv + item.montoAfectacionIgv; 
            item.cargosDescuentosItem[0].indicador= "descuento";
            (item.cargosDescuentosItem[0].codigoCargoDescuento= "00");
            (item.cargosDescuentosItem[0].factorCargoDescuento = parseFloat(parseFloat(item.porcentajeDescuento).toFixed(5)));
            item.cargosDescuentosItem[0].montoCargoDescuento = parseFloat(parseFloat(item.descuento).toFixed(2));
            item.cargosDescuentosItem[0].baseCargoDescuento = parseFloat(parseFloat(item.valorVentaSinAfectar).toFixed(2));
            }
          }
      }else{
        delete item.cargosDescuentosItem;
        item.cargosDescuentosItem = []
      }
      this.items = this.$store.getters.getitems;
      if (this.setIndex != -1) {
        Object.assign(this.items[this.setIndex], item);
        this.insertItem(this.items),
          this.$snotify.warning("Item Actualizado Correctamente", "Atencion"),
          (this.setIndex = -1);
        (this.setUpdateItem = false), this.initItem();
      } else {
        if (
          parseFloat(item.descuento) >
          parseFloat(item.valorUnitario * item.cantidad)
        ) {
          this.$snotify.warning(
            "El descuento no puede ser mayor al valor total por item",
            "Cuidado"
          );
        } else {
          this.items.push(item), this.insertItem(this.items), this.initItem();
        }
      }
    },
    initItem: function() {
      (this.descuento = false),
        (this.cantidad = 1),
        (this.codigoProducto = ""),
        (this.codigoTributo = ""),
        (this.tipoAfectacionIgv = ""),
        (this.descripcion = ""),
        (this.observacionItem = ""),
        (this.precioVentaUnitario = ""),
        (this.valorUnitario = ""),
        (this.codigoSunatBarras = ""),
        (this.descuentoItemMonto = ""),
        (this.descuentoItemPorcentaje = ""),
        (this.unidadMedidaCantidad = "NIU"),
        (this.especificacionIgv = "01");
      this.ventaGratuita = false;
      this.idProducto = "-";
      this.action.reset = true
    },
    deleteItem: function(index) {
      this.$swal({
        title: "Eliminar Item",
        text: "Seguro de eliminar este item ???",
        icon: "error",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          this.nroitemsprov = this.nroitemsprov - this.items[index].cantidad;
          this.items.splice(index, 1), this.insertItem(this.items);
          if (this.items.length == 0) {
            this.buttonRegularizacionAnticipos = true;
            this.disabledAnticipo = false;
          }
        } else {
          this.insertItem(this.items);
        }
      });
    },
    updateItem: function() {
      this.actualizado = this.dataitem.item.actualizado
      this.setUpdateItem = true;
      this.setIndex = this.dataitem.index;
      this.cantidad = this.dataitem.item.cantidad;
      this.unidadMedidaCantidad = this.dataitem.item.unidadMedidaCantidad;
      this.codigoProducto = this.dataitem.item.codigoProducto;
      this.idProducto = this.dataitem.item.idProducto;
      this.codigoSunatBarras = this.dataitem.item.codigoProductoSunat;
      this.descripcion = this.dataitem.item.descripcion;
      this.observacionItem = this.dataitem.item.observaciones;
      if(this.dataitem.item.adicional && this.dataitem.item.adicional.precioVentaUni !=''){
        this.precioVentaUnitario = this.dataitem.item.adicional.precioVentaUni;
      }else{
        this.precioVentaUnitario = this.dataitem.item.precioVentaUnitario;
      }
      this.valorUnitario = this.dataitem.item.valorUnitario;

      if(this.dataitem.item.adicional && this.dataitem.item.adicional.indicardorDsct == '01'){
          this.descuento = false
          this.descuentoItemMonto = this.dataitem.item.adicional.dsctSoles
      }else if(this.dataitem.item.adicional && this.dataitem.item.adicional.indicardorDsct == '02'){
          this.descuento = true
          this.descuentoItemPorcentaje = this.dataitem.item.adicional.dsctPorcentaje
      }else{
        this.descuentoItemMonto = ''
        this.descuentoItemPorcentaje = ''
      }
      if(this.dataitem.item.tipoAfectacionIgv == "10"){
        this.especificacionIgv = '01'
      }else if(this.dataitem.item.tipoAfectacionIgv == "20"){
          this.especificacionIgv = '03'
      }else if(this.dataitem.item.tipoAfectacionIgv == "30"){
          this.especificacionIgv = '02'
      }
    },
    executeUpdate: function() {
      this.addItem();
    },
    getReceiversProductCode: function(value) {
        if (value.length >=2) {
          axios
          .post(process.env.VUE_APP_API_URL + "productos/buscar", {
            token: this.$store.getters.userToken,
            filtro: "code",
            p: this.codigoProducto
          })
          .then(response => (
            (this.opcionesOrdenadas = response.data.response),
            this.listades = true
          ))
          .catch(error => (
            this.$snotify.error(error.response.data.msj, "Error"),
            this.listades = false
          ));
        }
      },
    calcItem: function() {
      var parent = this;
      if (parent.especificacionIgv === "01" && !parent.vunitario) {
        parent.Especificacion = parent.EspecificacionIgv;
        parent.especificacion = {
          codigo: "10",
          descripcion: "Operacion onerosa",
          codigoTributo: "1000"
        };
        parent.valorUnitario = parent.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
      } else if (parent.especificacionIgv === "01" && parent.vunitario) {
        parent.precioVentaUnitario = parent.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
      } else if (parent.especificacionIgv === "02" && !parent.vunitario) {
        parent.Especificacion = parent.EspecificacionIgv2;
        parent.especificacion = {
          codigo: "30",
          descripcion: "Operación Onerosa",
          codigoTributo: "9998"
        };
        parent.valorUnitario = parent.precioVentaUnitario;
      } else if (parent.especificacionIgv === "02" && parent.vunitario) {
        parent.precioVentaUnitario = parent.valorUnitario;
      } else if (parent.especificacionIgv === "03" && !parent.vunitario) {
        parent.Especificacion = parent.EspecificacionIgv3;
        parent.especificacion = {
          codigo: "20",
          descripcion: "Operación Onerosa",
          codigoTributo: "9997"
        };
        parent.valorUnitario = parent.precioVentaUnitario;
      } else if (parent.especificacionIgv === "03" && parent.vunitario) {
        parent.precioVentaUnitario = parent.valorUnitario;
      } else if (parent.tipoOperacion == "0200" && !parent.vunitario) {
        parent.valorUnitario = parent.precioVentaUnitario;
      } else if (parent.tipoOperacion == "0200" && parent.vunitario) {
        parent.precioVentaUnitario = parent.valorUnitario;
      }
    },
    calcItemGratuitos: function() {
      var parent = this;
      if (parent.especificacionIgv === "01" && !parent.vunitario) {
        parent.Especificacion = parent.EspecificacionIgv;
        parent.especificacion = {
          codigo: "15",
          descripcion: "Grabado - Bonificaciones",
          codigoTributo: "9996"
        };
        parent.valorUnitario = parent.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
      } else if (parent.especificacionIgv === "01" && parent.vunitario) {
        parent.precioVentaUnitario = parent.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
      } else if (parent.especificacionIgv === "02" && !parent.vunitario) {
        parent.Especificacion = parent.EspecificacionIgv2;
        parent.especificacion = {
          codigo: "31",
          descripcion: "Retiro por Bonificación",
          codigoTributo: "9996"
        };
        parent.valorUnitario = parent.precioVentaUnitario;
      } else if (parent.especificacionIgv === "02" && parent.vunitario) {
        parent.precioVentaUnitario = parent.valorUnitario;
      } else if (parent.especificacionIgv === "03" && !parent.vunitario) {
        parent.Especificacion = parent.EspecificacionIgv3;
        parent.especificacion = {
          codigo: "21",
          descripcion: "Transferencia gratuita",
          codigoTributo: "9996"
        };
        parent.valorUnitario = parent.precioVentaUnitario;
      } else if (parent.especificacionIgv === "03" && parent.vunitario) {
        parent.precioVentaUnitario = parent.valorUnitario;
      } else if (parent.tipoOperacion == "0200" && !parent.vunitario) {
        parent.valorUnitario = parent.precioVentaUnitario;
      } else if (parent.tipoOperacion == "0200" && parent.vunitario) {
        parent.precioVentaUnitario = parent.valorUnitario;
      }
    },
  }
};
</script>

<style scoped>
.searcher-field {
  z-index: 1000;
  position: absolute;
  max-height: 500px !important;
  overflow-y: scroll;
  width: 900px;
}
.searcher-result {
  font-size: smaller;
  padding: 2px 0px 2px 0px;
  cursor: pointer;
}
.sinresultados {
  padding: 0 5px 0 5px;
}
.sinresultados2 {
  padding: 0 10px 0 10px;
}
.btnagregarstyle {
  width: 325px;
}
.adicionalesOperacionItem {
  background-color: #ffb80e;
  padding: 0px;
}
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  }
  .upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  }
  .estilo {
  border: 2px solid teal;
  color: white;
  background-color: teal;
  padding: 8px 20px;
  border-radius: 5px;
  font-weight: bold;
  }
  .buttonagregar2{
    margin-top: -80px;
    padding-left: 300px;
  }
  .buttonagregar{
    margin-top: -80px;
    padding-left: 0px;
  }
  .colorBorde{
    border-color:#7e8fb9;
  }
  .searcher-result3{
    background-color: white;
  }
  .searcher-result2 {
    background-color: white;
    font-size: 1em;
    cursor: pointer;
  }
  .searcher-result2 :hover{
    background-color:skyblue;
    border:1px solid grey
  }
  .tablaborde{
    border: 1px solid #B8cdd5;
  }
  .centrarTitulo{
    text-align: center;
  }
</style>